import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { APP_MODE } from '@/config/domains'

// Import translation files
import nlCommon from '../locales/nl/common.json'
import nlAuth from '../locales/nl/auth.json'
import nlDashboard from '../locales/nl/dashboard.json'
import nlWizard from '../locales/nl/wizard.json'
import nlAdmin from '../locales/nl/admin.json'
import nlLayouts from '../locales/nl/layouts.json'
import nlNavigation from '../locales/nl/navigation.json'
import nlSettings from '../locales/nl/settings.json'
import nlLanding from '../locales/nl/landing.json'

import enCommon from '../locales/en/common.json'
import enAuth from '../locales/en/auth.json'
import enDashboard from '../locales/en/dashboard.json'
import enWizard from '../locales/en/wizard.json'
import enAdmin from '../locales/en/admin.json'
import enLayouts from '../locales/en/layouts.json'
import enNavigation from '../locales/en/navigation.json'
import enSettings from '../locales/en/settings.json'
import enLanding from '../locales/en/landing.json'

import esCommon from '../locales/es/common.json'
import esAuth from '../locales/es/auth.json'
import esDashboard from '../locales/es/dashboard.json'
import esWizard from '../locales/es/wizard.json'
import esAdmin from '../locales/es/admin.json'
import esLayouts from '../locales/es/layouts.json'
import esNavigation from '../locales/es/navigation.json'
import esSettings from '../locales/es/settings.json'

const resources = {
  nl: {
    common: nlCommon,
    auth: nlAuth,
    dashboard: nlDashboard,
    wizard: nlWizard,
    admin: nlAdmin,
    layouts: nlLayouts,
    navigation: nlNavigation,
    settings: nlSettings,
    landing: nlLanding,
  },
  en: {
    common: enCommon,
    auth: enAuth,
    dashboard: enDashboard,
    wizard: enWizard,
    admin: enAdmin,
    layouts: enLayouts,
    navigation: enNavigation,
    settings: enSettings,
    landing: enLanding,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    dashboard: esDashboard,
    wizard: esWizard,
    admin: esAdmin,
    layouts: esLayouts,
    navigation: esNavigation,
    settings: esSettings,
  },
}

// www marketing site is English-only; only the app supports language switching
const isWww = APP_MODE === 'www'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'wizard', 'admin', 'layouts', 'navigation', 'settings', 'landing'],

    detection: isWww
      ? { order: [], caches: [] } // no detection on www — always English
      : {
          order: ['localStorage'],
          caches: ['localStorage'],
          lookupLocalStorage: 'i18nextLng',
        },

    interpolation: {
      escapeValue: false, // React already escapes
    },

    react: {
      useSuspense: false,
    },
  })

export default i18n
